import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';

/**
 * DOCX → HTML 预览（mammoth）。
 */
export default function PlatformTutorialDocxPreview({ url = '', onDownload }) {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    const run = async () => {
      setLoading(true);
      setError('');
      setHtml('');
      if (!url) return;
      try {
        const mammoth = await import('mammoth');
        const res = await fetch(url);
        if (!res.ok) throw new Error(`加载失败（${res.status}）`);
        const buffer = await res.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer: buffer });
        if (!alive) return;
        setHtml(result.value || '<p>（文档无可见内容）</p>');
      } catch (e) {
        if (alive) setError(e?.message || 'DOCX 预览失败');
      } finally {
        if (alive) setLoading(false);
      }
    };
    run();
    return () => {
      alive = false;
    };
  }, [url]);

  if (loading) return <div className="pt-preview__empty">文档加载中…</div>;
  if (error) {
    return (
      <div className="pt-preview__fallback">
        <p>{error}</p>
        {onDownload ? (
          <button type="button" className="pt-preview__cta" onClick={onDownload}>
            <Download size={15} aria-hidden />
            下载文件
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div
      className="pt-preview__docx"
      // mammoth 输出受控 HTML（来自用户上传的教程文档）
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
